<div class="modal-custom modal fade" id="modalFeedback" data-keyboard="false"
     data-backdrop="static" role="dialog"
     aria-labelledby="modalNoteResumeLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <p class="modal-header-title">Feedback</p>
                <a (click)="closeModal('modalFeedback')" class="btn" type="button">
                    <svg-icon src="assets/svg/close.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body modal-body--small">

                <ul class="nav nav-tabs mb-3" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link is-cursor"
                           [ngClass]="{'active': feedbackType === 'behavioral', 'disabled': isTypeLocked && feedbackType !== 'behavioral'}"
                           role="tab"
                           (click)="setFeedbackType('behavioral')">{{'feedbackBehavioralTab'|translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link is-cursor"
                           [ngClass]="{'active': feedbackType === 'technical', 'disabled': isTypeLocked && feedbackType !== 'technical'}"
                           role="tab"
                           (click)="setFeedbackType('technical')">{{'feedbackTechnicalTab'|translate}}</a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane fade show active" role="tabpanel">
                        <div class="row">
                            <div class="col-12">
                                <div *ngIf="isNullOrUndefined(user)" class="input-material">
                                    <ng-multiselect-dropdown
                                            id="selectedUser"
                                            (onFilterChange)="onKey($event)"
                                            [placeholder]="'selecione'"
                                            [settings]="dropdownSettingsUnities"
                                            [data]="userByName"
                                            [(ngModel)]="selectedUser"
                                    >
                                    </ng-multiselect-dropdown>
                                    <label for="selectedUser" class="disabled">Colaborador</label>
                                </div>
                                <div class="row mb-3 align-items-center" *ngIf="!isNullOrUndefined(user)">
                                    <div class="col-auto">
                                        <img class="feedback_img" alt="photo"
                                             src="{{isNullOrUndefined(user.photo)? 'assets/images/user-lg.png': user.photo}}">
                                    </div>
                                    <dl class="col">
                                        <dt class="feedback_lbl mb-1">|{{user.re}}| {{user.name}}</dt>
                                        <dd class="feedback_value">{{'managersName.'+ user.profile|translate}}</dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <app-date-picker [isSingle]="true" [label]="'Data'"
                                                 [start]="feedback.date"
                                                 (selectDate)="selectedDate($event)"></app-date-picker>
                            </div>
                            <div class="col-12">
                                <div class="input-material">
                                      <textarea id="desc" [(ngModel)]="feedback.description" required maxlength="2000"
                                                class="form-control"></textarea>
                                    <label for="desc">{{'descrevaaqui'|translate}}</label>
                                </div>
                            </div>

                            <!-- Bloco exclusivo do feedback tecnico -->
                            <div class="col-12" *ngIf="feedbackType === 'technical'">
                                <div class="row align-items-center mb-3" style="gap: 15px">
                                    <div class="col-auto">
                                        <a class="btn btn-sm btn-outline-primary"
                                           [href]="templateFileUrl" download>
                                            <svg-icon class="right" src="assets/svg/downloads.svg"></svg-icon>
                                            {{'downloadTemplate'|translate}}
                                        </a>
                                    </div>
                                    <div class="col-auto">
                                        <label class="btn btn-sm btn-gray-fill mb-0"
                                               [ngClass]="{'disabled': uploading}">
                                            <input type="file" id="feedbackFiles" class="d-none" multiple
                                                   [disabled]="uploading"
                                                   (change)="onSelectFiles($event)"
                                                   accept=".xlsx, .xls, .pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf"/>
                                            <svg-icon class="right" [svgStyle]="{'transform':'rotate(180deg)'}"
                                                      src="assets/svg/downloads.svg"></svg-icon>
                                            {{'attachFile'|translate}}
                                        </label>
                                    </div>
                                    <div class="col-auto" *ngIf="uploading">
                                        <span class="feedback_value">{{'uploadingFiles'|translate}}</span>
                                    </div>
                                </div>

                                <p class="sub" *ngIf="countFiles() === 0">{{'noFilesAttached'|translate}}</p>

                                <!-- Ja persistidos (edicao) -->
                                <ng-container *ngIf="getPersistedFiles().length > 0">
                                    <p class="feedback_lbl mb-1">{{'attachedFiles'|translate}}</p>
                                    <div class="row no-gutters align-items-center mb-2"
                                         *ngFor="let f of getPersistedFiles()">
                                        <div class="col">
                                            <a *ngIf="!isNullOrUndefined(f.url)" class="feedback_lbl"
                                               [href]="f.url" target="_blank" download>{{f.name}}</a>
                                            <span *ngIf="isNullOrUndefined(f.url)"
                                                  class="feedback_lbl">{{f.name}}</span>
                                            <span class="feedback_value">
                                                {{formatFileSize(f.size)}}
                                                &middot; {{f.createdAt | date:'dd/MM/yyyy':'UTC-0'}}
                                                <ng-container *ngIf="f.createdBy">
                                                    &middot; {{'sentBy'|translate}} {{f.createdBy.name}}
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="col-auto">
                                            <a href="javascript:void('');" (click)="removePersistedFile(f)">
                                                <svg-icon src="assets/svg/close-circle.svg"></svg-icon>
                                            </a>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Adicionados agora, ainda nao persistidos -->
                                <ng-container *ngIf="uploadedFiles.length > 0">
                                    <p class="feedback_lbl mb-1 mt-2">{{'newAttachedFiles'|translate}}</p>
                                    <div class="row no-gutters align-items-center mb-2"
                                         *ngFor="let f of uploadedFiles; let i = index">
                                        <div class="col">
                                            <span class="feedback_lbl">{{f.name}}</span>
                                            <span class="feedback_value">{{formatFileSize(f.size)}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <a href="javascript:void('');" (click)="removeUploadedFile(i)">
                                                <svg-icon src="assets/svg/close-circle.svg"></svg-icon>
                                            </a>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <div class="col-12">
                                <p class="sub">{{'camposobrigatorios'|translate}}</p>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <a class="btn btn-outline-primary btn-lg w-100"
                           (click)="closeModal('modalFeedback')">Cancelar</a>
                    </div>
                    <div class="col-6">
                        <a (click)="onSave()" class="btn btn-primary btn-lg text-white w-100"
                           [ngClass]="{'disabled': uploading}">{{'salvar'|translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
